/* Entrada de obras — Cuadros Splash.

   Regla de oro: un cuadro NUNCA puede quedarse invisible. El CSS solo oculta
   mientras exista .cs-anim, y aqui hay tres redes de seguridad:
     1. Lo que ya esta en pantalla al cargar se anima de inmediato (sin esperar
        al observador, que en algunos navegadores no entrega la primera vez).
     2. Un temporizador global lo destapa todo pasados unos segundos, dispare
        o no el observador.
     3. Si no hay IntersectionObserver o el usuario pide menos movimiento, se
        muestra todo directamente y no se anima nada.

   Uso:  <div class="cs-reveal cs-reveal--brush"> ... </div>   (portada)
         <div class="cs-reveal cs-reveal--ink"> ... </div>     (colecciones) */

(function () {
  var PASO = 130; // ms entre pieza y pieza dentro de la misma fila
  var RESCATE = 5500; // ms tras los que se destapa todo pase lo que pase
  // OJO: RESCATE y el cinturon de animar() tienen que ser MAYORES que la
  // animacion mas larga (pincelada 1,9 s + texto 0,7 s de espera + 0,5 s) mas
  // el escalonado. Si se alarga la animacion y no estos dos, la limpieza corta
  // el barrido por la mitad.

  function reducido() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function terminar(item) {
    item.classList.remove('is-in');
    item.classList.add('is-done');
  }

  function enPantalla(el) {
    var r = el.getBoundingClientRect();
    var alto = window.innerHeight || document.documentElement.clientHeight;
    return r.top < alto && r.bottom > 0;
  }

  function animar(item, retardo) {
    if (item.classList.contains('is-in') || item.classList.contains('is-done')) return;

    item.style.setProperty('--cs-delay', retardo + 'ms');
    item.classList.add('is-in');

    var media = item.querySelector('.card__media');
    if (!media) return terminar(item);

    var fin = function () {
      media.removeEventListener('animationend', fin);
      terminar(item);
    };
    media.addEventListener('animationend', fin);
    // Cinturon: si la animacion no llega a disparar, limpiamos igual.
    setTimeout(fin, retardo + 3200);
  }

  function preparar(root) {
    if (root.dataset.csReady === '1') return;
    root.dataset.csReady = '1';

    var items = Array.prototype.slice.call(root.querySelectorAll('.grid__item'));
    if (!items.length) return;

    var destaparTodo = function () {
      items.forEach(function (i) {
        i.classList.add('is-done');
      });
    };

    if (reducido() || !('IntersectionObserver' in window)) {
      destaparTodo();
      return;
    }

    root.classList.add('cs-anim');

    // Red 2: pase lo que pase, a los pocos segundos todo visible.
    setTimeout(destaparTodo, RESCATE);

    // Red 1: lo que ya se ve al cargar, se anima ya.
    var visiblesYa = items.filter(enPantalla);
    visiblesYa.forEach(function (item, i) {
      animar(item, i * PASO);
    });

    var pendientes = items.filter(function (i) {
      return visiblesYa.indexOf(i) === -1;
    });
    if (!pendientes.length) return;

    var io = new IntersectionObserver(
      function (entradas) {
        var visibles = entradas.filter(function (e) {
          return e.isIntersecting;
        });
        if (!visibles.length) return;

        // Ordenamos por fila para que el escalonado se lea como una ola.
        visibles.sort(function (a, b) {
          var d = a.target.offsetTop - b.target.offsetTop;
          return d !== 0 ? d : a.target.offsetLeft - b.target.offsetLeft;
        });

        var base = null;
        var n = 0;
        visibles.forEach(function (e) {
          var item = e.target;
          io.unobserve(item);

          if (base === null) base = item.offsetTop;
          if (Math.abs(item.offsetTop - base) > 8) {
            base = item.offsetTop;
            n = 0;
          }
          animar(item, n * PASO);
          n++;
        });
      },
      { threshold: 0 }
    );

    pendientes.forEach(function (i) {
      io.observe(i);
    });
  }

  function iniciar() {
    document.querySelectorAll('.cs-reveal').forEach(preparar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }

  // Reaparece tras filtrar/paginar en colecciones o editar en el tema.
  document.addEventListener('shopify:section:load', iniciar);
  document.addEventListener('cs:reveal-refresh', iniciar);
})();
